export const SHORTCUTS = {
  OPEN_SEARCH_BAR: 'K',
} as const;
